import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OCPPProvider } from './contexts/OCPPContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from './components/Toast';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ChargerDetails from './pages/ChargerDetails';
import EmergencyControl from './pages/EmergencyControl';
import Users from './pages/Users';
import History from './pages/History';
import ConnectionLog from './pages/ConnectionLog';
import OcppTrace from './pages/OcppTrace';
import Simulator from './pages/Simulator';
import Sites from './pages/Sites';
import Fleet from './pages/Fleet';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <ToastContainer />
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={
                <ProtectedRoute>
                  <OCPPProvider>
                    <Header />
                    <main className="container">
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/charger/:chargerId" element={<ChargerDetails />} />
                        <Route path="/emergency" element={<EmergencyControl />} />
                        <Route path="/history" element={<History />} />
                        <Route path="/connection-log" element={<ProtectedRoute requireAdmin><ConnectionLog /></ProtectedRoute>} />
                        <Route path="/ocpp-trace" element={<ProtectedRoute requireAdmin><OcppTrace /></ProtectedRoute>} />
                        <Route path="/users" element={<ProtectedRoute requireAdmin><Users /></ProtectedRoute>} />
                        <Route path="/admin" element={<ProtectedRoute requireAdmin><Users /></ProtectedRoute>} />
                        <Route path="/simulator" element={<ProtectedRoute requireAdmin><Simulator /></ProtectedRoute>} />
                        <Route path="/sites" element={<ProtectedRoute requireAdmin><Sites /></ProtectedRoute>} />
                        <Route path="/fleet" element={<ProtectedRoute requireAdmin><Fleet /></ProtectedRoute>} />
                      </Routes>
                    </main>
                  </OCPPProvider>
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;